import { getCurrentFY, getProductionIndicesSearchRange, getCurrentMonth } from "../business/ReviewProductionIndices";
import { ProductionDeterminantHistory, ProductionDeterminantListing } from "../models/ProductionDeterminantListing";
import apiClient, { ACCEPT_TYPES } from "../../services/ApiClientService";
import { Utilities } from "../utils/utilities";
import { dataLoading } from "../decorators/LoadingAction.decorator";

export class ReviewProductionIndicesApi {
  @dataLoading(undefined)
  static async getProductionIndices() {
    var currentRF = getCurrentFY();
    var currentMonth = getCurrentMonth();
    var rf = getProductionIndicesSearchRange(currentRF, currentMonth);
    var result = await apiClient.get(`/api/production/productionDeterminants?from=${rf.From}&to=${rf.To}`);
    if (result.status === 200) {
      return {
        fiscalPeriods: result.data.fiscalPeriods,
        groups: result.data.groups,
      } as ProductionDeterminantListing;
    } else {
      return undefined;
    }
  }

  @dataLoading(false)
  static async autoUpdateIndices() {
    var result = await apiClient.get(`/api/production/AutoUpdateIndices`);
    return result.status === 200;
  }

  @dataLoading(undefined)
  static async getAutoUpdateLog() {
    return await apiClient.get(`/api/production/getAutoUpdateLog`);
  }

  @dataLoading("")
  static async getProductionDeterminantsExcel() {
    var currentRF = getCurrentFY();
    var currentMonth = getCurrentMonth();
    var rf = getProductionIndicesSearchRange(currentRF, currentMonth, 1, 1);
    var response = await apiClient.get(`/api/production/productionDeterminantsExcel?from=${rf.From}&to=${rf.To}`, { responseType: "arraybuffer", headers: { Accept: ACCEPT_TYPES.binary } });
    return response ? Utilities.blobFileDownload(response) : "";
  }

  @dataLoading(false)
  static async uploadIndices(fileData: any, isChecked: any) {
    var formData = new FormData();
    formData.append("file", fileData);
    formData.append("checked", isChecked);
    var res = await apiClient.post("/api/production/UploadIndices", formData, {
      headers: { "Content-Type": undefined },
    });

    // if failed, the response is a file and has this header data
    if (res.headers["content-disposition"]) {
      Utilities.fileDownload(res.data, "response.txt", "text/plain");
      return false;
    }

    return res.status === 200;
  }

  @dataLoading(false)
  static async updateExchangeRateIndex(fiscalYear: number, fiscalMonth: number) {
    var res = await apiClient.get(`/api/Production/updateExchangeRateIndex?fy=${fiscalYear}&fm=${fiscalMonth}`);
    return res.status === 200;
  }

  @dataLoading(false)
  static async updateIndex(determinant: ProductionDeterminantHistory) {
    var res = await apiClient.post("/api/Production/UpdateIndex", {
      index: determinant,
    });
    return res.status === 200;
  }
}
